<template>
    <apexchart width="100%"
               height="270"
               type="line"
               :options="options"
               :series="series" />
</template>

<script>
    import apexchart from 'vue3-apexcharts';
    import { addChartWatermark } from '../helpers/helpers';
    import { getTrans } from '../helpers/getTrans';

    export default {
        name: 'TransactionsChart',
        components: {
            apexchart,
        },
        props: {
            dates: {
                type: [Array, Object],
                default: () => [],
                required: true,
            },
            transactions: {
                type: [Array, Object],
                default: () => [],
                required: true,
            },
            users: {
                type: [Array, Object],
                default: () => [],
                required: true,
            },
            volume: {
                type: [Array, Object],
                default: () => [],
                required: true,
            },
        },
        data() {
            return {
                options: {
                    annotations: {
                        position: 'back',
                        images: [{
                            path: 'https://assets.bitdegree.org/crypto-prices/assets/bitdegree-watermark.png',
                            width: 97,
                            height: 30,
                            x: 10,
                            y: 5,
                            appendTo: '.apexcharts-grid',
                        }],
                    },
                    chart: {
                        type: 'line',
                        zoom: {
                            enabled: false,
                        },
                        toolbar: {
                            show: false,
                            tools: {
                                download: '<i class="fa-solid fa-share"></i>',
                            },
                        },
                    },
                    grid: {
                        show: false,
                    },
                    colors: ['#7FAFDE', '#E91E63', '#9C27B0'],
                    stroke: {
                        width: 2,
                        curve: 'smooth',
                    },
                    dataLabels: {
                        distributed: true,
                        enabled: false,
                    },
                    yaxis: [
                        {
                            labels: {
                                style: {
                                    colors: ['#7FAFDE'],
                                },
                                formatter(val) {
                                    if (val >= 1000000000) {
                                        return `$${(val / 1000000000).toFixed(2).replace(/\.0$/, '')}B`;
                                    }
                                    if (val >= 1000000) {
                                        return `${(val / 1000000).toFixed(2).replace(/\.0$/, '')}M`;
                                    }
                                    if (val >= 1000) {
                                        return `${(val / 1000).toFixed(2).replace(/\.0$/, '')}K`;
                                    }

                                    return (val).toFixed(2);
                                },
                            },
                            axisBorder: {
                                show: true,
                                color: '#E0E0E0',
                                offsetX: 0,
                                offsetY: 0,
                            },
                        },
                        {
                            opposite: true,
                            labels: {
                                style: {
                                    colors: ['#E91E63'],
                                },
                                formatter(val) {
                                    if (val >= 1000000000) {
                                        return `$${(val / 1000000000).toFixed(2).replace(/\.0$/, '')}B`;
                                    }
                                    if (val >= 1000000) {
                                        return `${(val / 1000000).toFixed(2).replace(/\.0$/, '')}M`;
                                    }
                                    if (val >= 1000) {
                                        return `${(val / 1000).toFixed(2).replace(/\.0$/, '')}K`;
                                    }

                                    return (val).toFixed(2);
                                },
                            },
                            axisBorder: {
                                show: true,
                                color: '#E0E0E0',
                                offsetX: 0,
                                offsetY: 0,
                            },
                        },
                        {
                            opposite: true,
                            labels: {
                                style: {
                                    colors: ['#9C27B0'],
                                },
                                formatter(val) {
                                    if (val >= 1000000000) {
                                        return `$${(val / 1000000000).toFixed(2).replace(/\.0$/, '')}B`;
                                    }
                                    if (val >= 1000000) {
                                        return `$${(val / 1000000).toFixed(2).replace(/\.0$/, '')}M`;
                                    }
                                    if (val >= 1000) {
                                        return `$${(val / 1000).toFixed(2).replace(/\.0$/, '')}K`;
                                    }

                                    return `$${(val).toFixed(2)}`;
                                },
                            },
                            axisBorder: {
                                show: true,
                                color: '#E0E0E0',
                                offsetX: 0,
                                offsetY: 0,
                            },
                        },
                    ],
                    tooltip: {
                        y: [
                            {
                                formatter(val) {
                                    if (typeof val === 'undefined') {
                                        return null;
                                    }
                                    if (val >= 1000000000) {
                                        return `$${(val / 1000000000).toFixed(2).replace(/\.0$/, '')}B`;
                                    }
                                    if (val >= 1000000) {
                                        return `${(val / 1000000).toFixed(2).replace(/\.0$/, '')}M`;
                                    }
                                    if (val >= 1000) {
                                        return `${(val / 1000).toFixed(2).replace(/\.0$/, '')}K`;
                                    }

                                    return (val).toFixed(2);
                                },
                            },
                            {
                                formatter(val) {
                                    if (typeof val === 'undefined') {
                                        return null;
                                    }
                                    if (val >= 1000000000) {
                                        return `$${(val / 1000000000).toFixed(2).replace(/\.0$/, '')}B`;
                                    }
                                    if (val >= 1000000) {
                                        return `${(val / 1000000).toFixed(2).replace(/\.0$/, '')}M`;
                                    }
                                    if (val >= 1000) {
                                        return `${(val / 1000).toFixed(2).replace(/\.0$/, '')}K`;
                                    }

                                    return (val).toFixed(2);
                                },
                            },
                            {
                                formatter(val) {
                                    if (typeof val === 'undefined') {
                                        return null;
                                    }
                                    if (val >= 1000000000) {
                                        return `$${(val / 1000000000).toFixed(2).replace(/\.0$/, '')}B`;
                                    }
                                    if (val >= 1000000) {
                                        return `$${(val / 1000000).toFixed(2).replace(/\.0$/, '')}M`;
                                    }
                                    if (val >= 1000) {
                                        return `$${(val / 1000).toFixed(2).replace(/\.0$/, '')}K`;
                                    }

                                    return `$${(val).toFixed(2)}`;
                                },
                            },
                        ],
                        labels: {
                            horizontalAlign: 'right',
                            useSeriesColors: true,
                        },
                    },
                    xaxis: {
                        categories: this.dates,
                        type: 'datetime',
                        axisBorder: {
                            show: !0,
                            color: '#EFEFEF',
                        },
                        labels: {
                            show: !0,
                            style: {
                                colors: '#C3C3C3',
                            },
                        },
                        axisTicks: {
                            show: !1,
                        },
                    },
                },
                series: [
                    {
                        name: getTrans('tools.uniqueActiveUsers', 'Unique Active Users'),
                        data: this.users,
                    },
                    {
                        name: getTrans('tools.transactions', 'Transactions'),
                        data: this.transactions,
                    },
                    {
                        name: getTrans('tools.volume', 'Volume'),
                        data: this.volume,
                    },
                ],
            };
        },
        mounted() {
            this.options.annotations.images[0].path = this.addChartWatermark(null);
        },
        methods: {
            nFormatter(num, digits) {
                const si = [
                    { value: 1, symbol: '' },
                    { value: 1E3, symbol: 'k' },
                    { value: 1E6, symbol: 'M' },
                    { value: 1E9, symbol: 'G' },
                ];
                const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
                let i;
                for (i = si.length - 1; i > 0; i--) {
                    if (num >= si[i].value) {
                        break;
                    }
                }

                return (num / si[i].value).toFixed(digits).replace(rx, '$1') + si[i].symbol;
            },
            addChartWatermark,
        },
    };
</script>
